import { User } from "modules/auth";

export interface InLieuOibPossibilities {
    forPersonOib?: string;
    forLegalIps?: string;
    toLegalIps?: string;
}

export const getInLieuOib = ({ forPersonOib, forLegalIps, toLegalIps }: InLieuOibPossibilities) => {
    if (forPersonOib) return forPersonOib;
    if (forLegalIps) return forLegalIps;
    if (toLegalIps) return toLegalIps;
    return undefined;
};

export const isRepresentingSomeone = (user: User) => {
    const inLieuOib = getInLieuOib(user);
    return inLieuOib && inLieuOib !== user.oib;
};
